module.exports = __webpack_public_path__ + "img/9.c8ec85bb.gif";